/*
        SUMMARY
            0 - Const / Variables
            1 - Function
*/


/*---------------------/ 1 - Const - Variables /-------------------*/


/*---------------------/ 2 - Functions /-------------------*/

var swiper = new Swiper(".mySwiper", {
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
  });

  //MODAL ABOUT

  const aboutBtn = document.getElementById('open-about');
  const modalAbout = document.getElementById('modal-about');
  const closeModalAbout = document.querySelector('#modal-about .close');

  aboutBtn.addEventListener('click', () => {
    modalAbout.classList.add('activate-modal')
  })

  closeModalAbout.addEventListener('click', () => {
    modalAbout.classList.remove('activate-modal')
  })



  //MODAL SUST

  const sustBtn = document.getElementById('open-sust');
  const modalSust = document.getElementById('modal-sust');
  const closeModalSust = document.querySelector('#modal-sust .close');

   sustBtn.addEventListener('click', () => {
    modalSust.classList.add('activate-modal')
  })

  closeModalSust.addEventListener('click', () => {
    modalSust.classList.remove('activate-modal')
  })

  //MODAL Pinus

  const pinusBtn = document.getElementById('open-pinus');
  const modalPinus = document.getElementById('modal-pinus');
  const closeModalPinus = document.querySelector('#modal-pinus .close');

   pinusBtn.addEventListener('click', () => {
    modalPinus.classList.add('activate-modal')
  })

  closeModalPinus.addEventListener('click', () => {
    modalPinus.classList.remove('activate-modal')
  })

// MODAL POLICY


const openPolicy = document.querySelectorAll('.open-policy');
const modalPolicy = document.getElementById('modal-policy');
const closeModalPolicy = document.querySelector('#modal-policy .close');

openPolicy.forEach(element => {
  element.addEventListener('click', () => {
    modalPolicy.classList.add('activate-modal')
  });
});


closeModalPolicy.addEventListener('click', () => {
  modalPolicy.classList.remove('activate-modal')
})


  // Get all buttons and images
const buttons = document.querySelectorAll('.bts-sust button');
const images = document.querySelectorAll('.sust-img-change img');

// Function to handle the button click
// buttons.forEach((button, index) => {
//     button.addEventListener('click', () => {
//         // Remove the 'active' class from all buttons
//         buttons.forEach(btn => btn.classList.remove('active'));

//         // Add 'active' class to the clicked button
//         button.classList.add('active');

//         // Hide all images
//         images.forEach(img => img.classList.add('d-none'));

//         // Show the image corresponding to the clicked button
//         if (images[index]) {
//             images[index].classList.remove('d-none');
//         }
//     });
// });

// Select all navigation links and sections
const navLinks = document.querySelectorAll('.nav-links a');
const sections = document.querySelectorAll('section');

// Function to update the active link based on the section's ID
function updateActiveLink(id) {
    navLinks.forEach(link => {
        // Remove 'active' from all links and add to the matching link
        link.classList.toggle('active', link.getAttribute('href').substring(1) === id);
    });
}

// Create an IntersectionObserver instance
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        // Check if the section is intersecting (visible on the screen)
        if (entry.isIntersecting) {
            updateActiveLink(entry.target.id);
        }
    });
}, {
    root: null,          // Use the viewport as the root
    threshold: 0.5,      // Trigger when 50% of the section is visible
    rootMargin: '0px 0px -50% 0px' // Trigger slightly before reaching the section center
});

// Observe each section
sections.forEach(section => observer.observe(section));

// Handle click events on nav links to apply 'active' class and smooth scroll
navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
        e.preventDefault();

        // Scroll to the respective section smoothly
        const targetSection = document.querySelector(link.getAttribute('href'));
        targetSection.scrollIntoView({ behavior: 'smooth' });

        // Update active link manually on click
        updateActiveLink(targetSection.id);
    });
});

document.querySelector('.svg-hero-down').addEventListener('click', function() {
    // Calculate 100vh in pixels
    const viewportHeight = window.innerHeight;

    // Scroll down by 100vh
    window.scrollBy({
      top: viewportHeight, // 100vh
      behavior: 'smooth' // Optional: for smooth scrolling
    });
  });

  document.querySelectorAll('.btns-hero button').forEach(button => {
    button.addEventListener('click', () => {
        const viewportHeight = window.innerHeight;

        // Scroll down by 100vh
        window.scrollBy({
          top: viewportHeight, // 100vh
          behavior: 'smooth' // Optional: for smooth scrolling
        });
    })
  })

  document.querySelectorAll('.product button').forEach(button => {
    button.addEventListener('click', () => {
        const viewportHeight = window.innerHeight;

        // Scroll down by 100vh
        window.scrollBy({
          top: viewportHeight, // 100vh
          behavior: 'smooth' // Optional: for smooth scrolling
        });
    })
  })

  document.querySelectorAll('.our-florest-content button').forEach(button => {
    button.addEventListener('click', () => {
        const viewportHeight = window.innerHeight;

        // Scroll down by 100vh
        window.scrollBy({
          top: viewportHeight, // 100vh
          behavior: 'smooth' // Optional: for smooth scrolling
        });
    })
  })

  window.addEventListener("scroll", function () {
    const header = document.getElementById("header");
    const changeLanguage = document.getElementById("changeLang");
    if (window.scrollY > 0) {
      header.classList.add("scrolled");
      changeLanguage.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
      changeLanguage.classList.remove("scrolled");
    }
  });


  document.getElementById("hamburger").addEventListener("click", function () {
    this.classList.toggle("active");
    document.getElementById("menu").classList.toggle("active");
  });

document.querySelectorAll('.menu-mobile ul li').forEach(button => {
    button.addEventListener('click', () => {
        document.getElementById("hamburger").classList.remove("active");
        document.getElementById("menu").classList.remove("active");
        document.querySelectorAll('.menu-mobile ul li a').forEach(btn => btn.classList.remove('active'));
        button.querySelector('a').classList.add('active');

    })
})
